var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTelefono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "#285171"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 30.3333H15.3334V11.6666H28.6667M28.6667 6.33325H15.3334C13.8534 6.33325 12.6667 7.51992 12.6667 8.99992V32.9999C12.6667 33.7072 12.9477 34.3854 13.4478 34.8855C13.9479 35.3856 14.6262 35.6666 15.3334 35.6666H28.6667C29.374 35.6666 30.0523 35.3856 30.5524 34.8855C31.0525 34.3854 31.3334 33.7072 31.3334 32.9999V8.99992C31.3334 8.29267 31.0525 7.6144 30.5524 7.1143C30.0523 6.6142 29.374 6.33325 28.6667 6.33325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelefono);
export default __webpack_public_path__ + "static/media/ic_telefono.09c339f9d8015913bab32be6b8fe2d49.svg";
export { ForwardRef as ReactComponent };